import { twMerge } from "tailwind-merge";

import type { TableRow } from "../../../types";
import {
  CHECKBOX_COLUMN_ID,
  NAME_COLUMN_ID,
  PERIOD_COLUMN_ID,
  RATE_COLUMN_ID,
  TOTAL_COLUMN_ID,
  ZONE_COLUMN_ID,
} from "../../dataFunctions/headers";
import {
  type StickyPosition,
  formatNumber,
  formatRate,
  getCellPaddingClass,
  getStickyStyle,
} from "../utils";

type Props = {
  columnId: string;
  totalsRow: TableRow;
  label: string;
  isIndividualTab: boolean;
  stickyPosition?: StickyPosition;
};

const getTotalsCellContent = (
  columnId: string,
  totalsRow: TableRow,
  label: string,
): { className?: string; content?: React.ReactNode } => {
  switch (columnId) {
    case CHECKBOX_COLUMN_ID:
    case ZONE_COLUMN_ID:
      return {};
    case NAME_COLUMN_ID:
    case PERIOD_COLUMN_ID:
      return { className: "text-left", content: label };
    case RATE_COLUMN_ID:
      return { content: formatRate(totalsRow.rate) };
    case TOTAL_COLUMN_ID:
      return {
        className: "border-l-2 border-l-[#E4DDDD]",
        content: formatNumber(totalsRow.total),
      };
    default:
      return {
        className: "border-l border-l-[#E4DDDD]",
        content: formatNumber(totalsRow.cells[columnId] ?? 0),
      };
  }
};

export const ReportingTableTotalsCell: React.FC<Props> = ({
  columnId,
  totalsRow,
  label,
  isIndividualTab,
  stickyPosition,
}) => {
  const { className, content } = getTotalsCellContent(
    columnId,
    totalsRow,
    label,
  );

  return (
    <td
      style={getStickyStyle(stickyPosition, { bottom: 0 })}
      className={twMerge(
        "sticky bottom-0 border-t-2 border-t-[#E4DDDD] bg-[#F3F2EC] py-[14px] text-right text-[13px] font-bold whitespace-nowrap tabular-nums",
        getCellPaddingClass(columnId, isIndividualTab),
        stickyPosition ? "z-8" : "z-6",
        className,
      )}
    >
      {content}
    </td>
  );
};
